
import React, { useRef, useState } from 'react';
import PropTypes from 'prop-types';
import ContentShowcaseView from 'common/designer-modules/modules/content-showcase';
import { generateApiParams, useContentInitialFetching } from 'common/designer-modules/siteDesigner';

const ContentShowcase = ({
   customSiteDesignerData,
   globalSettings,
   getFetchApi,
   collections,
   contentDefaultSorting,
   contentType,
   isMobile,
   isDisabled,
   isNextApp,
   getTheHref,
}) => {
   const contentShowcaseRef = useRef(null)
   const [media, setMedia] = useState({});
   const [isFetching, setIsFetching] = useState(true);
   const [isNextFetching, setNextIsFetching] = useState(false);
   const getFetchData = async (page = 1) => {
      setIsFetching(true);
      try {
         const query = generateApiParams(collections, contentDefaultSorting, contentType, page);
         const res = await getFetchApi(query, false);
         if(isNextApp){
            setMedia(res);
         } else {
            const { data } = res
            setMedia(data);
         }
         setIsFetching(false);
      } catch (error) {
         setIsFetching(false);

      }
   }
   useContentInitialFetching(contentShowcaseRef, getFetchData, isDisabled)

   const onNextContent = async () => {
      const nextPage = media.current_page + 1
      if(media.last_page < nextPage || isNextFetching) return
      setNextIsFetching(true)
      try {
         const query = generateApiParams(collections, contentDefaultSorting, contentType, nextPage);
         const res = await getFetchApi(query, false);
         let data = {}
         if(isNextApp){
            data = res
            setMedia(data);
         } else {
            data = res.data
            setMedia(data);
         }
         let newMedia = {
            ...data,
            data: [...media.data, ...data.data],
         }
         setMedia(newMedia);
         setNextIsFetching(false)
      } catch (error) {
         setNextIsFetching(false)

      }
   }

   return (
      <ContentShowcaseView
         customSiteDesignerData={ customSiteDesignerData }
         settings={ customSiteDesignerData }
         title={ customSiteDesignerData.title }
         data={ media }
         type={ contentType }
         isFetching={ isFetching }
         globalSettings={ globalSettings }
         onNextContent={ onNextContent }
         isMobile={ isMobile }
         isNextFetching={ isNextFetching }
         contentShowcaseRef={ contentShowcaseRef }
         getTheHref={ getTheHref }
         isNextApp={ isNextApp }
      />
   );
}
ContentShowcase.propTypes = {
   customSiteDesignerData: PropTypes.object,
   globalSettings: PropTypes.object,
   collections: PropTypes.object,
   getFetchApi: PropTypes.func,
   getTheHref: PropTypes.func,
   contentDefaultSorting: PropTypes.string,
   isMobile: PropTypes.bool,
   isNextApp: PropTypes.bool,
   isDisabled: PropTypes.bool,
   contentType: PropTypes.oneOf([
      'video', 'story', 'store', 'recorded_stream', 'photoset',
   ]),
};

export default ContentShowcase;


